export default function hasLinkInBioLab(
  seller: { labs?: { linkInBio?: boolean } | null } | null | undefined,
) {
  return Boolean(seller?.labs?.linkInBio);
}
